import { render, staticRenderFns } from "./WhyDifficult.vue?vue&type=template&id=60bf58b8&scoped=true"
import script from "./WhyDifficult.vue?vue&type=script&lang=js"
export * from "./WhyDifficult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bf58b8",
  null
  
)

export default component.exports